// extracted by mini-css-extract-plugin
export default {"Keywords":"SuggestMenu_Keywords__BCFGO","Keywords-header":"SuggestMenu_Keywords-header__8J+Bp","Keywords-body":"SuggestMenu_Keywords-body__O7dRA","item":"SuggestMenu_item__8l9FS"};